import React from 'react';

import { DialogContent } from '~/@sochi-components/SochiDialog/DialogContent';
import { ProjectQuery_project } from '~/graphql';
import { showCustomDialog } from '~/services/dialog';

import { DeliveryLineCreateForm } from './DeliveryLineCreateForm';

type DeliveryLineEditDialogProps = {
    project: ProjectQuery_project;
    onClose: (v: boolean) => void;
};

const DeliveryLineCreateDialog = ({ project, onClose }: DeliveryLineEditDialogProps) => {
    return (
        <DialogContent>
            <DeliveryLineCreateForm onClose={onClose} project={project} />
        </DialogContent>
    );
};

export const showDeliveryLineCreateDialog = (project: ProjectQuery_project) =>
    showCustomDialog({
        render: closeDialog => <DeliveryLineCreateDialog onClose={closeDialog} project={project} />,
    });
